import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23672 20591"
    {...props}
  >
    <path
      d="M11836 338c0 7845-2439 12070-11498 19915 9059-7845 13937-7845 22995 0C14274 12408 11836 8183 11836 338z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 676.329,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
